/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockOrderCheckInfoErrorGoodsProcessVo
 */
export interface StockOrderCheckInfoErrorGoodsProcessVo {
    /**
     * 处理分组，提交的时候前端给个随机的组号
     * @type {number}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    processGroup?: number;
    /**
     * 错误商品处理方法 1 废弃, 2 退货, 3 无视错误, 4 仅退款, 5 重新检查， 6 补发
     * @type {number}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    processMethod?: number;
    /**
     * 商品检查单ID
     * @type {number}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    checkOrderId?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    goodsCode?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    goodsName?: string;
    /**
     * 商品颜色
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    goodsColor?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    goodsSize?: string;
    /**
     * 商品错误数量
     * @type {number}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    goodsErrorQuantity?: number;
    /**
     * 商品错误状态名
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    goodsErrorStatusName?: string;
    /**
     * 商品单价
     * @type {number}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    goodsUnitPrice?: number;
    /**
     * 商品入库条码
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    marketBarcode?: string;
    /**
     * 入库商品名
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    marketProNm?: string;
    /**
     * 商品选项名
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    marketOptionName?: string;
    /**
     * 退货收件人姓名  申请退货用
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    receiverName?: string;
    /**
     * 退货收件人地址  申请退货用
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    receiverAddress?: string;
    /**
     * 退货收件人电话  申请退货用
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    receiverMobileNo?: string;
    /**
     * 退货收件人邮编  申请退货用
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    receiverZip?: string;
    /**
     * 退货收件人详细地址  申请退货用
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    receiverAddressDetail?: string;
    /**
     * 退货订单 取货方式1 仓库快递 2 卖家回收
     * @type {number}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    returnFetchGoodsMethod?: number;
    /**
     * 退货订单取货码
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    returnFetchGoodsCode?: string;
    /**
     * 退货订单取货时间
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    returnFetchGoodsDate?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    imgUrl?: string;
    /**
     * skuId
     * @type {number}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    skuId?: number;
    /**
     * sku编码
     * @type {string}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    skuCode?: string;
    /**
     * 购买类型 1 代买服务 2 转运服务
     * @type {number}
     * @memberof StockOrderCheckInfoErrorGoodsProcessVo
     */
    buyType?: number;
}

/**
 * Check if a given object implements the StockOrderCheckInfoErrorGoodsProcessVo interface.
 */
export function instanceOfStockOrderCheckInfoErrorGoodsProcessVo(value: object): value is StockOrderCheckInfoErrorGoodsProcessVo {
    return true;
}

export function StockOrderCheckInfoErrorGoodsProcessVoFromJSON(json: any): StockOrderCheckInfoErrorGoodsProcessVo {
    return StockOrderCheckInfoErrorGoodsProcessVoFromJSONTyped(json, false);
}

export function StockOrderCheckInfoErrorGoodsProcessVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockOrderCheckInfoErrorGoodsProcessVo {
    if (json == null) {
        return json;
    }
    return {
        
        'processGroup': json['processGroup'] == null ? undefined : json['processGroup'],
        'processMethod': json['processMethod'] == null ? undefined : json['processMethod'],
        'checkOrderId': json['checkOrderId'] == null ? undefined : json['checkOrderId'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'goodsName': json['goodsName'] == null ? undefined : json['goodsName'],
        'goodsColor': json['goodsColor'] == null ? undefined : json['goodsColor'],
        'goodsSize': json['goodsSize'] == null ? undefined : json['goodsSize'],
        'goodsErrorQuantity': json['goodsErrorQuantity'] == null ? undefined : json['goodsErrorQuantity'],
        'goodsErrorStatusName': json['goodsErrorStatusName'] == null ? undefined : json['goodsErrorStatusName'],
        'goodsUnitPrice': json['goodsUnitPrice'] == null ? undefined : json['goodsUnitPrice'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'receiverAddress': json['receiverAddress'] == null ? undefined : json['receiverAddress'],
        'receiverMobileNo': json['receiverMobileNo'] == null ? undefined : json['receiverMobileNo'],
        'receiverZip': json['receiverZip'] == null ? undefined : json['receiverZip'],
        'receiverAddressDetail': json['receiverAddressDetail'] == null ? undefined : json['receiverAddressDetail'],
        'returnFetchGoodsMethod': json['returnFetchGoodsMethod'] == null ? undefined : json['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': json['returnFetchGoodsCode'] == null ? undefined : json['returnFetchGoodsCode'],
        'returnFetchGoodsDate': json['returnFetchGoodsDate'] == null ? undefined : json['returnFetchGoodsDate'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'buyType': json['buyType'] == null ? undefined : json['buyType'],
    };
}

export function StockOrderCheckInfoErrorGoodsProcessVoToJSON(json: any): StockOrderCheckInfoErrorGoodsProcessVo {
    return StockOrderCheckInfoErrorGoodsProcessVoToJSONTyped(json, false);
}

export function StockOrderCheckInfoErrorGoodsProcessVoToJSONTyped(value?: StockOrderCheckInfoErrorGoodsProcessVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'processGroup': value['processGroup'],
        'processMethod': value['processMethod'],
        'checkOrderId': value['checkOrderId'],
        'goodsCode': value['goodsCode'],
        'goodsName': value['goodsName'],
        'goodsColor': value['goodsColor'],
        'goodsSize': value['goodsSize'],
        'goodsErrorQuantity': value['goodsErrorQuantity'],
        'goodsErrorStatusName': value['goodsErrorStatusName'],
        'goodsUnitPrice': value['goodsUnitPrice'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'receiverName': value['receiverName'],
        'receiverAddress': value['receiverAddress'],
        'receiverMobileNo': value['receiverMobileNo'],
        'receiverZip': value['receiverZip'],
        'receiverAddressDetail': value['receiverAddressDetail'],
        'returnFetchGoodsMethod': value['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': value['returnFetchGoodsCode'],
        'returnFetchGoodsDate': value['returnFetchGoodsDate'],
        'imgUrl': value['imgUrl'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'buyType': value['buyType'],
    };
}

